import { usePlayer } from "../../player/context.js";
import { ControlsContextProvider } from "./context.js";
import { ControlsCore, ControlsDataAttrs } from "@videojs/core";
import { logMissingFeature, selectControls } from "@videojs/core/dom";
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/controls/root.tsx
/** Manages controls state and provides it to the compound parts. Does not render an element. */
function ControlsRoot({ children, visibility = ControlsCore.defaultProps.visibility }) {
	const controls = usePlayer(selectControls);
	const [core] = useState(() => new ControlsCore());
	core.setProps({ visibility });
	core.setMedia(controls ?? null);
	const state = core.getState();
	if (!state) {
		logMissingFeature("Controls.Root", "controls");
		return null;
	}
	return /* @__PURE__ */ jsx(ControlsContextProvider, {
		value: {
			state,
			stateAttrMap: ControlsDataAttrs
		},
		children
	});
}
//#endregion
export { ControlsRoot };

//# sourceMappingURL=root.js.map